import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./BurgerMenu.module.scss";

interface BurgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation("common");
  const [isScreenWide, setIsScreenWide] = useState<boolean>(
    window.innerWidth > 1050
  );

  useEffect(() => {
    const handleResize = () => {
      setIsScreenWide(window.innerWidth > 1050);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isScreenWide) {
      onClose();
    }
  }, [isScreenWide, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.burgerMenu}>
      <div className={styles.menu}>
        <button
          className={styles.close}
          onClick={onClose}
          aria-label={t("common.close")}
          title={t("common.close")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            aria-hidden="true"
          >
            <path
              fill="#202428"
              fillRule="evenodd"
              d="M.293.293a1 1 0 0 1 1.414 0l30 30a1 1 0 0 1-1.414 1.414l-30-30a1 1 0 0 1 0-1.414Zm31.414 0a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Zm-18 18a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Z"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>

        <div className="container">
          <nav className={styles.nav} aria-label={t("nav.menu")}>
            <Link to="/services/berlin" onClick={onClose}>
              {t("nav.workshopBerlin")}
            </Link>

            <Link to="/services/eu" onClick={onClose}>
              {t("nav.postShipping")}
            </Link>

            <Link to="/shop" onClick={onClose}>
              {t("nav.shop")}
            </Link>

            <Link to="/about-us" onClick={onClose}>
              {t("nav.about")}
            </Link>

            <Link to="/partners" onClick={onClose}>
              {t("nav.partner")}
            </Link>

            <Link to="/career" onClick={onClose}>
              {t("nav.career")}
            </Link>

            <Link to="/faq" onClick={onClose}>
              {t("nav.faq")}
            </Link>

            <Link to="/contact" onClick={onClose}>
              {t("nav.contact")}
            </Link>

            <Link to="/reviews" onClick={onClose}>
              {t("nav.reviews")}
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default BurgerMenu;
